import * as _ from 'lodash';
import { NotificationSent } from './NotificationSent.model';

export class ContractFinancial {
    projectStarted: boolean = false;
    startDate: Date = new Date();
    contractStatus: Number;
    customerDate: Date = new Date();
    canUseCustomerBrand: Boolean;
    customerBrandObservation: String;
    professionalRequested: Boolean;
    professionalRequestedObservation: String;
    notificationSent: NotificationSent = new NotificationSent();

    constructor(data?) {
        this.populate(data);
    }

    populate(data) {
        _.forOwn(data, (value, key) => {
            this[key] = value;
        });
    }

    loadFromServer(r: any) {
        if (r.projectStarted != undefined) 
            this.projectStarted = r.projectStarted;

        if (r.startDate != undefined)
            this.startDate = r.startDate;

        if (r.contractStatus != undefined)
            this.contractStatus = r.contractStatus;
        
        if (r.customerDate != undefined)
            this.customerDate = r.customerDate;

        if (r.notificationSent !== undefined)
            this.notificationSent.loadFromServer(r.notificationSent);

        if (r.canUseCustomerBrand != undefined)
            this.canUseCustomerBrand = r.canUseCustomerBrand;

        if (r.customerBrandObservation != undefined)
            this.customerBrandObservation = r.customerBrandObservation;

        if (r.professionalRequested != undefined)
            this.professionalRequested = r.professionalRequested;

        if (r.professionalRequestedObservation != undefined)
            this.professionalRequestedObservation = r.professionalRequestedObservation;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/project/ContractFinancial.model.ts